module.exports = __webpack_public_path__ + "static/img/price.282ed5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product_introduce/price.png
// module id = pmph
// module chunks = 0